<template>
  <Modal v-model="smallknotBagModal" :title="$t('key1004758')" width="600" :transfer="false"
    :mask-closable="false" @on-visible-change="smallknotBagChange">
    <h2 class="mb10">
      <span>{{ $t('key1004760') }}</span>
      <span class="themeColor font-weight-bold mr5 ml5">{{ total }}</span>
      <span>{{ $t('key1004761') }}</span>
    </h2>
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="smallknotBagColumns"
        :data="smallknotBagTableData">
      </Table>
    </div>
    <Form ref="smallknotBagForm" class="mt20" :model="smallknotBagForm" :label-width="100" @submit.native.prevent>
      <Row type="flex" :gutter="gutterItem">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004759')" prop="weight" :rules="{required: true, type: 'number', message: $t('key1004757'),trigger: 'change'}">
            <InputNumber style="width: 100%" v-model="smallknotBagForm.weight" :min="0" :max="99999999"/>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="smallknotBagModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="printLabelbagBtn">{{ $t('key1004762') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: "smallknotBagModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      smallknotBagModal: false,
      smallknotBagColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'center',
          minWidth: 250,
          render(h, params) {
            let imgPath = params.row.pictureUrl;
            let spec = params.row.productGoodsSpecifications;
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'},
                  [
                    h('p', {
                      style: {
                        width: '70px',
                        textAlign: 'right'
                      }
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                    h('p', {
                      style: {
                        flex: 1,
                        textAlign: 'left'
                      }
                    }, params.row.title),
                  ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1,
                      textAlign: 'left'
                    }
                  }, params.row.ymsSku),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1,
                      textAlign: 'left'
                    },
                    class: 'color-green'
                  }, spec),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          width: 100,
          key: 'scanQuantity',
          align: 'center',
        },
      ],
      smallknotBagTableData: [],
      smallknotBagForm: {
        weight: null
      },
      total: 0,
      ymsThirdPlatformPackageId: null
    };
  },
  methods: {
    // 初始化数据
    initSmallknotBagData(data, ymsThirdPlatformPackageId) {
      let v = this;
      v.smallknotBagTableData = data;
      v.total = v.smallknotBagTableData.reduce(
        (pre, cur) => {
          return pre + cur.scanQuantity;
        },
        0
      );
      v.ymsThirdPlatformPackageId = ymsThirdPlatformPackageId;
      v.smallknotBagModal = true;
    },
    // 打印标签并结袋
    printLabelbagBtn() {
      let v = this;
      v.$refs['smallknotBagForm'].validate((valid) => {
        if (valid) {
          let query = {
            weight: v.smallknotBagForm.weight,
            weightUnit: 0, // 重量单位 0：g 1:kg, 默认g
            ymsThirdPlatformPackageId: v.ymsThirdPlatformPackageId
          };
          v.axios.put(api.put_ymsThirdPlatformPackage_endPacking, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data) {
                v.smallknotBagModal = false;
                v.$emit('smallknotBagBtn', data);
              }
            }
          });
        }
      });
    },
    // 监听弹窗
    smallknotBagChange(value) {
      if (!value) {
        this.smallknotBagTableData = [];
        this.ymsThirdPlatformPackageId = null;
        this.$refs['smallknotBagForm'].resetFields();
      }
    }
  }
};
</script>

<style scoped>

</style>